export default "__VITE_ASSET__BsJ$po$2__"